import { render, staticRenderFns } from "./DownloadReceipt.vue?vue&type=template&id=0d90f9c6&scoped=true"
import script from "./DownloadReceipt.vue?vue&type=script&lang=js"
export * from "./DownloadReceipt.vue?vue&type=script&lang=js"
import style0 from "./DownloadReceipt.vue?vue&type=style&index=0&id=0d90f9c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d90f9c6",
  null
  
)

export default component.exports